export function selectElementTextContent(e: EventTarget & HTMLElement) {
  const selection = window.getSelection()
  if (selection) {
    selection.selectAllChildren(e)
  }
}
